import * as React from "react";
import { conference } from "@/api";
import { useReducer } from "react";
import * as config from "@/config/const";
// @ts-ignore
// import { ReactComponent as Sound } from "@/assets/near_16KHz_16I.wav";
export const checkStoredPlayTips =  (conferenceNo:string) => {
    conference.checkPlayTips( conferenceNo).then((res)=>{
        
        console.log("playTips", res.playTips);
        if(res.playTips===1){
           //开提示音
           playMusic();
        } else {
          //不开提示音
          
        }

        if(res.muteJoinMeeting===0){
          // 不静音
        } else {
          // 静音
        }
      })
    
}
function getSiteInfo() {
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const port = window.location.port;

  return {
      isLocalhost: isLocalhost,
      port: port
  };
}

const playMusic = () => {
  const siteInfo = getSiteInfo();
  // config.BASEURL
    let url = config.BASEURL.replace("/meetingapi","")+'/output.mp3';
    if(siteInfo.isLocalhost ){
      url = 'http://localhost:'+siteInfo.port+'/output.mp3';
    }
    console.log("playMusic:"+config.BASEURL)
    const audio = new Audio(url); // 替换为您的音乐文件路径
    audio.play().catch(error => console.error('播放音频失败:', error));
};